/*
 * @Description: 
 * @Author: ywj
 * @Date: 2023-04-06 09:33:52
 * @LastEditTime: 2024-12-25 11:35:13
 * @LastEditors: ywj@originqc.com
 */
import { useAppSelector } from "@/redux/hooks";
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import { assetsUrl } from '@/utils/assetsUrl';
import './footer-bottom.scss'

const policyPDF = `${assetsUrl}assets/files/pdf/%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96.pdf`;
const policyPDFEn = `${assetsUrl}assets/files/pdf/PrivacyPolicy.pdf`;
const servicePDF=`${assetsUrl}assets/files/pdf/用户信息服务条款.pdf`
const servicePDFEn =`${assetsUrl}assets/files/pdf/UserInformationServiceTerms.pdf`
const FooterBottom = () => {
  const lang = useAppSelector((state) => state.common.language);
  const { t } = useTranslation('footer');
  const openFile = () => {
    if (lang === 'en') {
      window.open(policyPDFEn);
    } else {
      window.open(policyPDF);
    }
  };
  const openFileService = () => {
    if (lang === 'en') {
      window.open(servicePDFEn);
    } else {
      window.open(servicePDF);
    }
  };
  return (
    <div className='footerBottom'>
      <div
        className={lang === 'zh' ? 'footerBottomBox' : 'footerBottomBoxEn'}
      >
        <span> {t('OriginqInformation', { year: new Date().getFullYear() })}</span>
        <span className="line">|</span>
        {/* <Link onClick={()=>window.scrollTo({top:0})} to='/copyrightWord' className='bq_color'>
          {t('copyRight')}
        </Link> */}
        {/* <span className="line">|</span> */}
        <a
          href='https://beian.miit.gov.cn/'
          target='_blank'
          rel='noopener noreferrer'
        >
          {t('areaOriginqInfo')}
        </a>
        <span className="line">|</span>
        <span> {t('areaOriginqText')}</span>
        <span className="line">|</span>
        <span className='privacy-text' onClick={openFileService}>
          {t('OriginqService')}
        </span>
        <span className="line">|</span>
        <span className='privacy-text' onClick={openFile}>
          {t('OriginqPrivacy')}
        </span>
      </div>
    </div>
  )
}
export default FooterBottom